import { TYPES } from "./service.type";

const initState = {
  all: null,
};

const serviceReducer = (state = initState, action) => {
  const { type, payload } = action;
  switch (type) {
    case TYPES.SELECT_ALL_SERVICES:
      return {
        ...state,
        all: payload,
      };

    default:
      return state;
  }
};

export default serviceReducer;
